import React, { useState } from 'react';
import { X, Sun, Moon, Sunrise } from 'lucide-react';
import { ShiftConfig } from '../../../hooks/useUserShift';

interface PortalGuruModalPilihanShiftProps {
    shiftTime?: string; // Legacy support
    onSelect: (shiftName: string) => void;
    onClose: () => void;
    availableShifts?: ShiftConfig[]; // New: List of active shifts
}

export const PortalGuruModalPilihanShift: React.FC<PortalGuruModalPilihanShiftProps> = ({ shiftTime, onSelect, onClose, availableShifts }) => {

    // Normalize data: If availableShifts not provided, construct single from legacy shiftTime
    const shiftsToRender = availableShifts && availableShifts.length > 0
        ? availableShifts
        : shiftTime ? [{ name: 'Shift Kerja', start: shiftTime.split(' - ')[0], end: shiftTime.split(' - ')[1] } as ShiftConfig]
        : [];

    const [selectedShiftName, setSelectedShiftName] = useState<string>(shiftsToRender.length === 1 ? shiftsToRender[0].name || 'Shift Kerja' : '');

    const getShiftIcon = (startStr: string) => {
        const start = parseInt(startStr.split(':')[0], 10);
        if (!isNaN(start)) {
            if (start >= 5 && start < 11) return { Icon: Sunrise, bg: 'bg-yellow-100', text: 'text-yellow-600' };
            if (start >= 11 && start < 18) return { Icon: Sun, bg: 'bg-orange-100', text: 'text-orange-600' };
            return { Icon: Moon, bg: 'bg-indigo-100', text: 'text-indigo-600' };
        }
        return { Icon: Sun, bg: 'bg-gray-100', text: 'text-gray-600' };
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-end justify-center sm:items-center px-4 pb-6 sm:p-0">
            <div className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity" onClick={onClose}></div>
            <div className="relative w-full max-w-sm bg-white rounded-3xl p-5 shadow-2xl ring-1 ring-white/10 transform transition-all animate-in slide-in-from-bottom-10 fade-in duration-300">
                <div className="absolute top-4 right-4">
                    <button onClick={onClose} className="p-1 rounded-full text-gray-500 hover:bg-gray-100 transition-colors">
                        <X size={20} />
                    </button>
                </div>
                <div className="text-center mb-6 mt-1">
                    <h3 className="text-xl font-bold text-[#111813] tracking-tight">Pilih Shift Kerja</h3>
                    <p className="text-xs text-[#63886f] mt-1">Silahkan pilih shift yang sesuai</p>
                </div>

                <div className="flex flex-col gap-3 mb-6">
                    {shiftsToRender.map((shift, index) => {
                        const { Icon, bg, text } = getShiftIcon(shift.start);
                        const shiftName = shift.name || 'Shift Kerja';
                        const isSelected = selectedShiftName === shiftName;

                        return (
                            <div
                                key={index}
                                className={`relative group cursor-pointer`}
                                onClick={() => setSelectedShiftName(shiftName)}
                            >
                                <div className={`flex items-center justify-between p-4 rounded-2xl border-2 transition-all cursor-pointer ${isSelected ? 'bg-[#40513B]/5 border-[#40513B] shadow-sm' : 'border-transparent bg-gray-50 hover:bg-gray-100'}`}>
                                    <div className="flex items-center gap-3">
                                        <div className={`size-10 rounded-full flex items-center justify-center ${bg} ${text}`}>
                                            <Icon size={24} />
                                        </div>
                                        <div className="flex flex-col text-left">
                                            <span className="text-sm font-bold text-[#111813]">{shiftName}</span>
                                            <span className="text-xs font-medium text-[#63886f]">{shift.start} - {shift.end} WIB</span>
                                        </div>
                                    </div>
                                    <div className={`size-5 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-[#40513B] bg-[#40513B]' : 'border-gray-300'}`}>
                                        <div className={`size-2 bg-white rounded-full transition-opacity ${isSelected ? 'opacity-100' : 'opacity-0'}`}></div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <button
                    onClick={() => selectedShiftName && onSelect(selectedShiftName)}
                    disabled={!selectedShiftName}
                    className={`w-full py-3.5 font-bold rounded-xl shadow-lg transition-all active:scale-[0.98] flex items-center justify-center gap-2 ${selectedShiftName ? 'bg-[#40513B] hover:bg-[#344230] text-white shadow-[#40513B]/25' : 'bg-gray-200 text-gray-400 cursor-not-allowed shadow-none'}`}
                >
                    Konfirmasi Presensi
                </button>
            </div>
        </div>
    );
};
